import React from "react";
import GiottoProjects from "../../shared/GiottoProjects";

/**
 * Organization-specific Giotto tab component
 */
const OrgGiotto = ({ orgId }) => {
  return (
    <GiottoProjects 
      orgId={orgId}
      showBreadcrumb={false}
      showTitle={false}
      showTabs={true}
    />
  );
};

export default OrgGiotto;